import {createAction} from 'typesafe-actions';
import * as Types from './types';

export const hideSlowWarning = createAction(
  '@view/multiRunWorkspace/hideSlowWarning',
  action => (ref: Types.Ref) => action({ref, at: new Date().toISOString()})
);

export type ActionType = ReturnType<typeof hideSlowWarning>;
